(() => {
  const PRODUCT_ROOT_SELECTOR = '[data-ecomhard-xb-product-wishlist]';
  const HEADER_SELECTOR = 'xb-wishlist-header[data-ecomhard-xb-header]';

  function dedupeHeaderWishlist() {
    const customHeader = document.querySelector(HEADER_SELECTOR);
    if (!customHeader) return;

    document.querySelectorAll('#header xb-wishlist-header').forEach((item) => {
      if (item !== customHeader) item.style.display = 'none';
    });
  }

  function dedupeProductWishlist() {
    const customButton = document.querySelector(PRODUCT_ROOT_SELECTOR);
    if (!customButton) return;

    const productInfo = customButton.closest('[id^="ProductInfo-"]');
    if (!productInfo) return;

    productInfo.querySelectorAll('.xb-wishlist__btn-custom').forEach((item) => {
      if (item !== customButton && !customButton.contains(item)) {
        item.style.display = 'none';
      }
    });
  }

  function updateProductVariant(variant) {
    if (!variant) return;

    document.querySelectorAll(PRODUCT_ROOT_SELECTOR).forEach((root) => {
      root.querySelectorAll('.xb-wishlist__add, .xb-wishlist__remove').forEach((button) => {
        button.setAttribute('xb-product-variant', variant.id || '');
        button.setAttribute('xb-is-in-stock', variant.available ? 'true' : 'false');
      });
    });
  }

  function isButtonVisible(button) {
    if (!button) return false;

    const style = window.getComputedStyle(button);
    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      !button.hidden &&
      button.getAttribute('aria-hidden') !== 'true'
    );
  }

  function getRealWishlistState(root) {
    if (!root) return null;

    const addButton = root.querySelector('.xb-wishlist__add');
    const removeButton = root.querySelector('.xb-wishlist__remove');
    const loadingButton = root.querySelector('.xb-wishlist__loading');

    if (isButtonVisible(loadingButton)) return null;
    if (isButtonVisible(removeButton)) return true;
    if (isButtonVisible(addButton)) return false;

    return null;
  }

  function applyVisualWishlistState(root, filled) {
    if (!root || typeof filled !== 'boolean') return;
    root.classList.toggle('ecomhard-xb-wishlist--filled', filled);
  }

  function syncVisualWishlistState(root) {
    const realState = getRealWishlistState(root);
    if (realState !== null) {
      applyVisualWishlistState(root, realState);
    }
  }

  function triggerBookmarkFlip(root, targetFilled) {
    if (!root) return;

    root.classList.remove('ecomhard-xb-wishlist--flip');
    void root.offsetWidth;
    root.classList.add('ecomhard-xb-wishlist--flip');

    /*
      Faz a troca contorno/preenchido exatamente quando o Bookmark está
      praticamente de perfil. Assim o usuário não vê a substituição do SVG.
    */
    window.setTimeout(() => {
      applyVisualWishlistState(root, targetFilled);
    }, 165);

    window.setTimeout(() => {
      root.classList.remove('ecomhard-xb-wishlist--flip');
    }, 360);

    /*
      Depois que a XB sair do loading, confirmamos o estado real.
      Se a ação falhar por qualquer motivo, o visual volta automaticamente.
    */
    window.setTimeout(() => syncVisualWishlistState(root), 650);
    window.setTimeout(() => syncVisualWishlistState(root), 1200);
  }

  function connectBookmarkFlip() {
    document.addEventListener(
      'click',
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const button = target.closest(
          `${PRODUCT_ROOT_SELECTOR} .xb-wishlist__add, ${PRODUCT_ROOT_SELECTOR} .xb-wishlist__remove`
        );

        if (!button) return;

        const root = button.closest(PRODUCT_ROOT_SELECTOR);
        const isAdding = button.classList.contains('xb-wishlist__add');

        triggerBookmarkFlip(root, isAdding);
      },
      true
    );
  }

  function connectWishlistStateObservers() {
    document.querySelectorAll(PRODUCT_ROOT_SELECTOR).forEach((root) => {
      if (root.dataset.ecomhardWishlistObserver === 'true') return;
      root.dataset.ecomhardWishlistObserver = 'true';

      syncVisualWishlistState(root);

      const observer = new MutationObserver((mutations) => {
        const internalChange = mutations.some((mutation) => {
          const target = mutation.target;
          return (
            target instanceof Element &&
            target !== root &&
            target.closest(PRODUCT_ROOT_SELECTOR) === root
          );
        });

        if (!internalChange) return;

        window.requestAnimationFrame(() => {
          if (!root.classList.contains('ecomhard-xb-wishlist--flip')) {
            syncVisualWishlistState(root);
          }
        });
      });

      observer.observe(root, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
      });

      /* A XB inicializa de forma assíncrona. */
      [100, 300, 700, 1200, 2000].forEach((delay) => {
        window.setTimeout(() => syncVisualWishlistState(root), delay);
      });
    });
  }

  function connectVariantChange() {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          updateProductVariant(event?.data?.variant);
        });
      }
    } catch (error) {
      // A XB continua funcional mesmo se o pub/sub do tema não estiver disponível.
    }
  }

  function init() {
    dedupeHeaderWishlist();
    dedupeProductWishlist();
    connectVariantChange();
    connectBookmarkFlip();
    connectWishlistStateObservers();

    // A XB pode injetar a integração automática de forma assíncrona.
    // Mantemos nossa posição customizada como fonte de verdade.
    const observer = new MutationObserver(() => {
      dedupeHeaderWishlist();
      dedupeProductWishlist();
      connectWishlistStateObservers();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
